export const ADDONS = [
  { id: "extrapage", label: "Additional page", cost: 75 },
  { id: "gbp-setup", label: "Google Business Profile setup", cost: 100 },
  { id: "gbp-optimize", label: "Google Business Profile optimization", cost: 75 },
  { id: "copy", label: "Basic copywriting help (per page)", cost: 50 },
  { id: "booking", label: "Booking integration", cost: 100 },
  { id: "payments", label: "Payment integration", cost: 125 },
  { id: "photos", label: "Photography help", cost: 150 },
];
